import React from "react";

function NavItem({ active, label, onClick, icon }) {
  return (
    <button
      onClick={onClick}
      className={[
        "w-full flex items-center gap-3 px-4 py-3 rounded-2xl transition text-left",
        active
          ? "bg-white/10 text-white border border-white/10"
          : "text-white/70 hover:text-white hover:bg-white/5",
      ].join(" ")}
    >
      <span className="text-lg">{icon}</span>
      <span className="font-medium">{label}</span>
    </button>
  );
}

export default function Sidebar({ current, setCurrent }) {
  return (
    <aside className="hidden lg:flex lg:w-72 p-4">
      <div className="w-full rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-4">
        <div className="px-2 py-3">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-blue-500 to-violet-500 grid place-items-center text-white font-bold">
              STS
            </div>
            <div>
              <div className="text-white font-semibold leading-tight">Inventory Admin</div>
              <div className="text-white/60 text-sm">Smart Tech Solutions</div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-2">
          <NavItem
            active={current === "dashboard"}
            label="Dashboard"
            icon="📊"
            onClick={() => setCurrent("dashboard")}
          />
          <NavItem
            active={current === "items"}
            label="Items"
            icon="📦"
            onClick={() => setCurrent("items")}
          />
        </div>

        <div className="mt-8 px-2">
          <div className="rounded-2xl bg-black/30 border border-white/10 p-4">
            <div className="text-white font-semibold">Tip</div>
            <div className="text-white/70 text-sm mt-1">
              Use barcode search to instantly find products.
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
